export enum PaymentsPages {
    AddNewBankDraft = "AddNewBankDraft",
    BankAccountRoutingNumberChange = "BankAccountRoutingNumberChange",
    ChangeBankDraftDate = "ChangeBankDraftDate",
    OneTimePayment = "OneTimePayment",
    ChangeBankDraftAmount = "ChangeBankDraftAmount"
}